import React from 'react'
import './Card.modules.css'
export default function Card({title,duration,score}) {
  return (
    <div className='card'>
      <b>{title}</b>
      <div style={{display:'flex',justifyContent:"space-between"}}>
        <div>{score}</div>
        <div>{duration}</div>
      </div>
    </div>
  )
}
